/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { WearablesStrictHttpResponse } from '../../wearables-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MemberStatistics } from '../../models/member-statistics';

export interface ExternalStatisticsProfileIdGet$Params {

/**
 * The member profile identifier.
 */
  profileId: string;

/**
 * The number of months of history to include (default: 12).
 */
  numberOfMonths?: number;
}

export function externalStatisticsProfileIdGet(http: HttpClient, rootUrl: string, params: ExternalStatisticsProfileIdGet$Params, context?: HttpContext): Observable<WearablesStrictHttpResponse<MemberStatistics>> {
  const rb = new RequestBuilder(rootUrl, externalStatisticsProfileIdGet.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.query('numberOfMonths', params.numberOfMonths, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as WearablesStrictHttpResponse<MemberStatistics>;
    })
  );
}

externalStatisticsProfileIdGet.PATH = '/External/Statistics/{profileId}';
